import { SVGProps } from 'react';

const SvgPencil = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12" {...props}>
        <path d="m8.372 4 .626.627-6.053 6.04h-.613v-.614L8.372 4Zm2.4-4a.667.667 0 0 0-.467.193l-1.22 1.22 2.5 2.5 1.22-1.22a.664.664 0 0 0 0-.94l-1.56-1.56A.655.655 0 0 0 10.772 0Zm-2.4 2.127L.998 9.5V12h2.5l7.374-7.373-2.5-2.5Z" />
    </svg>
);
export default SvgPencil;
